
import { useTheme, ListItem, ListItemButton, ListItemIcon, ListItemText, Chip, Box, SvgIcon } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useContext } from 'react';
import { DrawerContext, DrawerValues } from '../contexts/DrawerContext';
import { DrawerNavItem } from '../interfaces/DrawerNavItem';
import { shouldShowPreviewTag } from '../../../../utils/featureAccess';

export const NavItem = (props: { item: DrawerNavItem, onClick: (() => void) | undefined }) => {
  const { t } = useTranslation('drawer');
  const theme = useTheme();
  const { pathname, search } = useLocation();
  const { isHighLighted, selectedNavItem, isMobile } = useContext(DrawerContext) as DrawerValues;
  const showAsHighlighted = isHighLighted(props.item, pathname, search);
  const selectedNavItemToUse = isMobile ? selectedNavItem : undefined;
  const isCurrentSelected = props.item.translationKey === selectedNavItemToUse?.translationKey;

  const colourToUse = () => {
    if (showAsHighlighted && !isMobile) return theme.palette.primary[400];
    if (isCurrentSelected && !isMobile) return theme.palette.primary[500];
    return 'transparent';
  };
  const unSelectedColor = theme.palette.primary.contrastText == '#000000' ? theme.palette.primary[900] : theme.palette.primary[100];

  if (!props.item.canRender) {
    return <></>;
  }

  return (
    <ListItem
      sx={{
        flexDirection: 'column',
        alignItems: 'stretch',
        borderRadius: '4px',
        p: 0,
        backgroundColor: colourToUse(),
      }}
    >
      <ListItemButton onClick={props.onClick}
        sx={{
          borderRadius: '4px',
          minHeight: '44px',
          display: 'flex',
          padding: '8px 12px',
          flexDirection: 'row',
        }}
      >
        <ListItemIcon
          sx={{
            minWidth: 0,
            fontSize: 8,
            height: '24px',
            color: `${showAsHighlighted ? 'common.white' : 'primary.light'}`,
          }}
        >
          {props.item.variant == 'customIcon' ? props.item.icon : <SvgIcon>{props.item.icon}</SvgIcon>}
        </ListItemIcon>
        <ListItemText
          primary={(
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Box component="span"
                sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {t(props.item.translationKey ?? '')}
              </Box>
              {/* "demo" is an internal-only gate with no badge. "preview" is signposted, but not
                  while Demo Mode is enabled (Demo Mode also grants access to preview content). */}
              {shouldShowPreviewTag(props.item.status) && (
                <Chip label={t('preview')}
                  size="small"
                  color="warning"
                  variant="outlined"
                  sx={{ fontWeight: 400, height: '18px', fontSize: 11 }} />
              )}
            </Box>
          )}
          primaryTypographyProps={{
            color: `${showAsHighlighted ? theme.palette.common.white : theme.palette.primary.contrastText}`,
            fontSize: 16,
            height: '24px',
            fontWeight: 600,
            pl: '16px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        />
      </ListItemButton>
    </ListItem>
  );
};